import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const ContainerHeader = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	align-items: center;
`;

export const ContainerTitles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-right: auto;
	padding: 50px 0;

	h2 {
		font-family: ${tokens.font_family_primary};
		color: ${tokens.color_primary};
		font-weight: 600;
		font-size: 20px;
	}

	p {
		font-family: ${tokens.font_family_primary};
		color: ${tokens.color_gray_dark};
		font-weight: 400;
		font-size: 18px;
	}
`;
